var _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketOktionLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Oktion_Logo",
    "data-name": "Oktion Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 102.193,
    viewBox: "0 0 282 102.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32657",
    "data-name": "Group 32657",
    transform: "translate(131.049 6.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9860",
    "data-name": "Rectangle 9860",
    width: 1.692,
    height: 87.466,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32658",
    "data-name": "Group 32658",
    transform: "translate(161.2 32.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21472",
    "data-name": "Path 21472",
    d: "M188.376,52.415a19.593,19.593,0,0,1-1.493,7.961,11.265,11.265,0,0,1-4.378,5.174,12.936,12.936,0,0,1-13.135,0,11.264,11.264,0,0,1-4.378-5.174,17.165,17.165,0,0,1-1.592-7.761V50.325a18.349,18.349,0,0,1,1.592-7.96,11.532,11.532,0,0,1,4.378-5.274,12.936,12.936,0,0,1,13.135,0,11.533,11.533,0,0,1,4.378,5.274,19.929,19.929,0,0,1,1.493,7.96Zm-4.08-1.99c0-3.682-.7-6.567-2.189-8.458a7.971,7.971,0,0,0-12.438,0c-1.492,1.99-2.289,4.677-2.289,8.259v2.289a14.216,14.216,0,0,0,2.289,8.458,7.166,7.166,0,0,0,6.169,3.085,7.38,7.38,0,0,0,6.169-2.886c1.493-1.891,2.189-4.677,2.289-8.359Z",
    transform: "translate(-163.4 -34.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21473",
    "data-name": "Path 21473",
    d: "M200.568,56.19l-2.488,2.587v8.16H194.1V34.1h3.98V54l2.09-2.587,7.164-7.662h4.776L203.055,53.4l10.05,13.433h-4.677Z",
    transform: "translate(-163.552 -34.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21474",
    "data-name": "Path 21474",
    d: "M221.759,38.2v5.572h4.279v3.085h-4.279V61.186a3.265,3.265,0,0,0,.6,2.09,2.308,2.308,0,0,0,1.99.7,8.037,8.037,0,0,0,1.891-.3v3.184a10.947,10.947,0,0,1-3.085.4,4.772,4.772,0,0,1-3.98-1.592,6.982,6.982,0,0,1-1.393-4.577V46.857H213.6V43.772h4.179V38.2h3.98Z",
    transform: "translate(-163.648 -34.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21475",
    "data-name": "Path 21475",
    d: "M230.8,37.689a2.26,2.26,0,0,1,.6-1.592,2.469,2.469,0,0,1,1.791-.7,2.129,2.129,0,0,1,1.791.7,2.421,2.421,0,0,1,0,3.184,2.985,2.985,0,0,1-3.582,0A2.26,2.26,0,0,1,230.8,37.689Zm4.279,29.255H231.1V43.858h3.98Z",
    transform: "translate(-163.733 -34.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21476",
    "data-name": "Path 21476",
    d: "M240.4,55.242a13.274,13.274,0,0,1,1.294-6.07,9.791,9.791,0,0,1,9.155-5.672,9.792,9.792,0,0,1,7.662,3.284c1.99,2.189,2.886,5.075,2.886,8.757v.3a13.273,13.273,0,0,1-1.294,6.07,10.053,10.053,0,0,1-3.682,4.179,10.373,10.373,0,0,1-5.572,1.493,9.792,9.792,0,0,1-7.662-3.284c-1.99-2.189-2.886-5.075-2.886-8.657v-.4Zm3.98.4a9.685,9.685,0,0,0,1.791,6.169,5.849,5.849,0,0,0,4.776,2.289,5.673,5.673,0,0,0,4.776-2.388,10.843,10.843,0,0,0,1.791-6.667,9.878,9.878,0,0,0-1.791-6.169,5.673,5.673,0,0,0-4.776-2.388,5.986,5.986,0,0,0-4.776,2.289A11.92,11.92,0,0,0,244.38,55.64Z",
    transform: "translate(-163.78 -34.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21477",
    "data-name": "Path 21477",
    d: "M270.281,43.9l.1,2.886a8.626,8.626,0,0,1,6.965-3.383c4.876,0,7.364,2.786,7.364,8.259V66.983h-3.98V51.659a4.963,4.963,0,0,0-1.194-3.682,4.616,4.616,0,0,0-3.483-1.194,5.648,5.648,0,0,0-3.383,1,7.5,7.5,0,0,0-2.289,2.687V66.983H266.4V43.9Z",
    transform: "translate(-163.909 -34.146)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21478",
    "data-name": "Path 21478",
    d: "M49.76,1.1A48.279,48.279,0,0,0,21.9,88.864l.3,14.428L33.64,94.934A48.3,48.3,0,1,0,49.76,1.1ZM65.084,51.848a15.188,15.188,0,0,1-5.97,9.951,16.447,16.447,0,0,1-4.577,2.289,15.875,15.875,0,0,1-6.866.5,12.7,12.7,0,0,1-2.786-.7l-6.169,3.383.4-6.866a9.3,9.3,0,0,1-1.592-1.791A15.007,15.007,0,0,1,34.436,47.47a15.188,15.188,0,0,1,5.97-9.951A15.548,15.548,0,0,1,51.85,34.733,15.885,15.885,0,0,1,62.1,40.6h0A14.868,14.868,0,0,1,65.084,51.848Z",
    transform: "translate(-1.4 -1.1)",
    fill: "#ffc629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketOktionLogo);
export default __webpack_public_path__ + "static/media/ticket_oktion_logo.85fda18b160e0156700ca8d7548cfbfb.svg";
export { ForwardRef as ReactComponent };